<template>
    <div class="iconCom" @click="getbtnClick">
        <svg class="text_svg" id="text_svg"
             :width="trans.width+'px'"
             :height="trans.height+'px'"
             >
            <rect class="rect" v-if="config.type === 'rect'"
                  :width="trans.width"
                  :height="trans.height"
                  :style="{fill:config.fillColor,stroke:config.strokeColor,strokeWidth:config.strokeWidth+'px'}"/>
            <ellipse class="ellipse" v-if="config.type === 'ellipse'"
                     :cx="trans.width > trans.height ? config.lockScale?trans.width/2:trans.width/2 : config.lockScale?trans.width/2:trans.width/2"
                     :cy="trans.width > trans.height ? config.lockScale?trans.height/2:trans.height/2 : config.lockScale?trans.height/2:trans.height/2"
                     :rx="trans.width > trans.height ? config.lockScale?trans.height/2*config.proportion:trans.width/2*config.proportion : config.lockScale?trans.width/2*config.proportion:trans.width/2*config.proportion"
                     :ry="trans.width > trans.height ? config.lockScale?trans.height/2*config.proportion:trans.height/2*config.proportion : config.lockScale?trans.width/2*config.proportion:trans.height/2*config.proportion"
                     :style="{fill:config.fillColor,stroke:config.strokeColor,strokeWidth:config.strokeWidth+'px'}"/>
            <line class="line" v-if="config.type === 'line'"
                  x1="0" y1="0"
                  :x2="trans.width" :y2="trans.height"
                  style="stroke:rgb(99,99,99);stroke-width:2"/>
        </svg>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/26 3:57 下午
     */
    import {pathFullScreen} from '@/assets/js/basis.js'

    export default {
        name: 'iconCom',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            option: {
                type: Object,
                default: ''
            },
            trans: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                svgColor: '#fff',
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {
            getbtnClick() {
                if (this.$route.path.indexOf('/fullScreen') !== -1) {
                    pathFullScreen({
                        id: this.config.push.url,
                        type: 1
                    })
                }
            },
        },
        watch: {
            config(a) {
                this.svgColor = a.color;
            }
        },
        mounted() {
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .iconCom {
        width: 100%;
        height: 100%;
        position: relative;
        text-align: center;
        >svg{
            width: 100%;
            height: 100%;
        }
    }
</style>
